import React, { useRef, useImperativeHandle, forwardRef } from "react";

/**
 * VideoViewer — renders a video element with native controls.
 *
 * Exposes ref.current.getMediaEl() for crop access.
 */

const VideoViewer = forwardRef(function VideoViewer({ src, name }, ref) {
  const videoRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getMediaEl: () => videoRef.current,
  }), []);

  return (
    <video
      ref={videoRef}
      src={src}
      controls
      style={styles.video}
    />
  );
});

export default VideoViewer;

const styles = {
  video: {
    maxWidth: "100%",
    maxHeight: "100%",
    outline: "none",
    display: "block",
    border: "2px solid #000000",
    borderRadius: "4px",
  },
};